<template lang="pug">
.crud()
  .container-fluid
    vm-row.heading(vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
        div
          h2 {{ $t('strings.shipment_details') }}:
          span {{ $t('strings.description', {attribute: $t('strings.products')}) }}
        div(style="display:none;")
          vm-button(type="default" icon="list")
          vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
      vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
        div
          vm-tooltip(:text="$t('strings.options')" delay=".5s")
            vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
              vm-button(type="border" icon="more-horizotnal" color="#afbbc6")
              vm-dropdown-menu
                vm-dropdown-item.d-flex.justify-content-between(@click="exportViewShipmentProducts")
                  vm-icon(icon="download-outline")
                  slot &nbsp;{{ $t('strings.export') }}
    vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        vm-table(max-height="350px" :data="shipmentProducts")
          template(slot="header")
            .d-flex.justify-content-between
              vm-input(ref="search" icon="search" size="small" v-model="filters.product_code" @keyup.enter="loadRecords({page: 1})" width="300px")
              .d-flex.justify-content-between(@click="loadCatalogsFilters()")
                vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                  vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="default" icon="funnel-outline" size="small")

                    vm-dropdown-menu(class="filters")
                      .heading.d-flex.justify-content-between
                        h4 {{ $t('strings.filters') }}
                        vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                      vm-date-picker.filter(type="daterange" :label="$t('shipments.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.shipment_created_at")
                      vm-select.filter(:placeholder='$t("strings.multiple")' :label='$t("shipments.status_id")' multiple autocomplete v-model="filters.shipment_status_ids" @change="$emit('filter', filters)")
                        vm-select-item(:key='index', :value='item.id', :text="$t('shipments.'+ item.id)", v-for='item,index in shipmentStatuses')
                      .filter.d-flex
                        vm-button(@click="loadRecords({page: 1})") {{ $t('strings.apply') }}
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('shipment_details.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column == 'shipment_created_at' || column == 'shipment_arrival_date'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                slot(v-if="column == 'quantity'") {{data[indextr][column] | currency('')}}
                slot(v-if="column != 'shipment_created_at' && column != 'quantity' && column != 'shipment_status_id' && column != 'shipment_arrival_date'") {{data[indextr][column]}}
                vm-status-indicator(v-if="column == 'shipment_status_id'" :pulse="data[indextr][column]" :color="colorStatus(data[indextr][column])") {{ $t('shipments.'+ data[indextr][column]) }}
        vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ShipmentProducts')

export default {
  name: 'ViewShipmentProducts',
  components: {},
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: [
      'purchase_order_folio_display',
      'product_code_display',
      'quantity',
      'shipment_status_id',
      'shipment_created_at',
      'shipment_arrival_date',
      'shipment_folio'
    ],
    columnsOrderBy: [],
    attributeModal: 'name',
    status: [
      {
        value: 1,
        color: 'warning'
      },
      {
        value: 2,
        color: 'success'
      },
      {
        value: 3,
        color: 'warning'
      },
      {
        value: 4,
        color: 'success'
      },
      {
        value: 5,
        color: 'danger'
      }
    ],
    filters: {}
  }),
  async created () {
    await this.loadCatalogsFilters()
  },
  computed: {
    ...mapGetters(['shipmentProducts', 'catalog', 'pagination', 'filterParams', 'shipmentStatuses'])
  },
  methods: {
    ...mapActions([
      'loadData',
      'loadCatalog',
      'exportRecords',
      'applyFilter',
      'getShipmentStatuses'
    ]),
    async loadCatalogsFilters () {
      if (this.shipmentStatuses.length === 0) await this.getShipmentStatuses()
    },
    exportViewShipmentProducts () {
      this.exportRecords()
    },
    async loadRecords ({ page }) {
      await this.loadData({ page, filters: this.filters })
    },
    async clearFilter () {
      this.filters = {}
      await this.loadRecords({ page: 1 })
    },
    handleChange (dates) {
      this.filters.shipment_created_at = dates
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.con-tablex.vm-table--content {
  overflow: visible !important;
}
thead.vm-table--thead-table {
  position: sticky;
  top: 0px;
  z-index: 999;
  background-color: white;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
